export function miniStoryboardSegmentPath(projectId, episodeId, segmentId) {
  return `/project/${encodeURIComponent(projectId)}/episode/${encodeURIComponent(episodeId)}/mini-storyboard?${new URLSearchParams({ segmentId: String(segmentId) })}`;
}

// Use the persistent segment ID, not its sequence number (which can change on insertion).
export function findLinkedMiniStoryboardSegment(segments, search) {
  const segmentId = new URLSearchParams(search).get('segmentId');
  if (!segmentId || !/^\d+$/.test(segmentId)) return null;
  return segments.find(segment => String(segment.id) === segmentId) || null;
}
